const ACTIONS = {
    UPDATE_DAMAGE_POLICY: 'DAMAGE_POLICY/UPDATE'
};

export default {...ACTIONS};
